//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { reparationConfirmQuery, selectClaimLogList, adjustResultOperateTypeUpdate } from '@/api/policymanagement';
import Print from '@/api/print';
export default {
  name: "AdjustResultNote",
  data: function data() {
    return {
      // 遮罩层
      checked: false,
      insuredName: '',
      claimCode: '',
      buttonFlag: false,
      showFlag: true,
      formData: {
        accidentInfo: {
          policyNo: '',
          claimNo: '',
          insuredName: '',
          damagePlace: ''
        },
        compensationInfo: {
          calculateFormula: '',
          compensationAmount: 0,
          compensationAmountStr: '',
          currencyName: '',
          currencyEnName: '',
          accountName: '',
          accountBank: '',
          accountCode: ''
        }
      },
      dialogVisible: false,
      tableData: []
    };
  },
  created: function created() {
    var _this = this;

    var claimCode = this.$route.params.claimCode;
    this.claimCode = claimCode;
    reparationConfirmQuery({
      'claimCode': claimCode
    }).then(function (res) {
      console.log(res);
      _this.formData = res;
      var userType = res.userType;

      if (userType == '02') {
        _this.buttonFlag = true;
      } else if (userType = '01') {
        if (res.applicantInfo.identifyNumber == null || res.applicantInfo.identifyNumber == '') {
          _this.checked = true;
          _this.buttonFlag = true;
        } else {
          if (res.operateType == '2') {
            _this.checked = true;
            _this.buttonFlag = true;
          } else {
            _this.buttonFlag = false;
          }
        }
      } else {
        _this.buttonFlag = true;
      }
    });
  },
  methods: {
    toHuanHang: function toHuanHang(val) {
      var oldList = val;
      var newList = oldList.replace(/\n/ig, '<br/>');
      return newList;
    },
    getList: function getList() {
      console.log('开启！！！');
    },
    operateRecord: function operateRecord() {
      var _this2 = this;

      console.log('操作记录');
      selectClaimLogList({
        'claimCode': this.claimCode
      }).then(function (res) {
        console.log(res);
        _this2.tableData = res;
      });
      this.dialogVisible = true;
    },
    printTo: function printTo(index, row) {
      //printHtml(document.getElementById('printId').innerHTML)
      //window.print()
      this.operateFlag = false;
      setTimeout(function () {}, 2000);
      console.log('21312');
      this.$print(this.$refs.Print); // 使用
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    confirmOrReject: function confirmOrReject(type) {
      var _this3 = this;

      this.buttonFlag = true;
      console.log(type);

      if (type == '2') {
        if (this.checked == false) {
          this.$message({
            type: 'warning',
            message: '未勾选同意确认信息！'
          });
          this.buttonFlag = false;
          return;
        }
      }

      var data = {
        'claimCode': this.claimCode,
        'operateType': type
      };
      adjustResultOperateTypeUpdate(data).then(function (res) {
        if (res.resultCode == '0000') {
          if (type == '2') {
            _this3.$message({
              message: '请求成功',
              type: 'success'
            }); // 确认成功关闭导航栏


            _this3.$store.dispatch('delVisitedViews', _this3.$route); //跳转


            _this3.$router.push({
              path: '/claimapplication/claimApplyquery'
            });
          } else if (type == '3') {
            _this3.$message({
              message: '请求成功',
              type: 'success'
            });

            _this3.$router.go('-1'); // 关闭导航栏


            _this3.$store.dispatch('delVisitedViews', _this3.$route);
          }
        } else {
          _this3.$message({
            type: 'warning',
            message: '请求失败，失败信息:' + res.resultMsg
          });
        }
      });
    }
  }
};